import React from "react";
import {OrbitComponent} from "../../../base-components/orbit-component/orbit-component";
import {observer} from "mobx-react";
import {TranslationsHelper} from "../../../../services/translation/translations-helper";
import {DropDownComponent, DropDownItem, IDropDownSelectionResult} from "./drop-down.component";
import {NullableNumber} from "../../../../../common/types/nullable-types";
import {parseCommaSeparatedNumbers} from "../../../../../utils/string-helpers";
import {TimeSpan} from "@sparkware/app-utils";
import {CyClass} from "../../../../../common/cy-classes";

interface IntervalReminderDropDownComponentProps {
    onItemSelected: (value: NullableNumber) => void;
}

export const IntervalReminderDropDownComponent = observer(
    class IntervalReminderDropDownComponent extends OrbitComponent<IntervalReminderDropDownComponentProps> {

        private get _translations(): TranslationsHelper {
            return new TranslationsHelper(this.services.translation);
        }

        private _getReminderIntervals(): DropDownItem[] {
            const values = parseCommaSeparatedNumbers(this.services.configuration.servicesConfigs.Regulation.Spain.IntervalReminderInMinutes)
                                      .map(minutes => TimeSpan.fromMinutes(minutes))
            return values.map(val => {
                return {
                    value: val.totalSeconds,
                    text: val.totalMinutes < 60 ? this._translations.minutes(val.totalMinutes) : this._translations.hours(val.totalHours)
                };
            });
        }

        private _onItemSelectedHandler = async (value: NullableNumber): Promise<IDropDownSelectionResult> => {
            this.props.onItemSelected(value);
            return {
                cancel: false
            };
        }

        render() {
            return (
                <DropDownComponent label={this.services.translation.translate('GAMBLING_SESSION_REMINDER_INTERVAL_DROP_DOWN_LABEL')}
                                   items={this._getReminderIntervals()}
                                   onItemSelected={this._onItemSelectedHandler}
                                   className={CyClass('cy-gambling-session-limit-interval-reminder-select')}/>
            );
        }
    }
);